export default "__VITE_ASSET__CczN$qsD__"